import React, { useState } from 'react';
import { Container, Form, Button, Modal } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { addSurgerySurgical } from '../../UserFunctions';
import AlertGen from '../../generic/AlertGen';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import Select from "react-select";
import { addPatient } from '../../UserFunctions';
import '../../styles/styles.css';

export class AddSurgeryRequest extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      alertShow: false,
      setShow: '',
      message: '',
      current_id: '',
      isFailure: false,
      patientO: [],
      surgeryTO: null,
      seniorTO: null,
      addPatientModalShow: false
    }
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onNoteChange = this.onNoteChange.bind(this);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });

  }

  componentDidMount() {
    const url = 'https://server-soroka-demo.herokuapp.com/patients/get_all';
    fetch(url, {
      method: "GET"
    }).then(res => res.json()).then(patients_data => {
      this.setState({
        patientO: patients_data.map((p => {
          return {
            value: p.patient_id,
            label: p.patient_id + " - " + p.first_name + " " + p.last_name
          };
        }))
      })
      // console.log(this.state.patientO)
    }).catch((err) => {
      console.log(err)
    });

    const urlST = 'https://server-soroka-demo.herokuapp.com/surgeries_types/get_all';
    fetch(urlST, {
      method: "GET"
    }).then(res => res.json()).then(surgeryT_data => {
      var surgeryT_options = surgeryT_data.map(surT_data => {
        return (<option key={surT_data.surgery_type_id} value={surT_data.surgery_type_id}>{surT_data.name}</option>)
      });
      this.setState({ surgeryTs: surgeryT_data, surgeryTO: surgeryT_options });
    }).catch((err) => {
      console.log(err)
    });

    const urlSENIOR = 'https://server-soroka-demo.herokuapp.com/surgeons_seniors/get_all';
    fetch(urlSENIOR, {
      method: "GET"
    }).then(res => res.json()).then(surgeon_data => {
      var surgeon_data_names = surgeon_data.map(sur_data => {
        return (<option key={sur_data.senior_id} value={sur_data.senior_id}>{sur_data.first_name} {sur_data.last_name}</option>)
      });
      this.setState({ surgeryTs: surgeon_data, seniorTO: surgeon_data_names });
    }).catch((err) => {
      console.log(err)
    });
  }



  openModal = () => {
    this.setState({ addPatientModalShow: true });
  }


  printPatientId = (e) => {
    // console.log(document.getElementById("patient_id").value);
    console.log(e.value)
    this.setState({ current_id: e.value });
  }

  onNoteChange = (e) => {
    const message = e.message
    this.setState(() => ({ message }));
  };


  onSubmit(e) {

    e.preventDefault();

    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    today = mm + '/' + dd + '/' + yyyy;

    const pre_op_request = {
      request_id: document.getElementById("request_id").value,
      surgery_type_fk: document.getElementById("surgery_type").value,
      patient_id: this.state.current_id,
      urgency: document.getElementById("urgency").value,
      complexity: document.getElementById("complexity").value,
      duration: document.getElementById("duration").value,
      status: document.getElementById("status").value,
      cancellations: document.getElementById("cancellations").value,
      entrance_date: today,
      specific_senior: document.getElementById("specific_senior").value,
      pre_op_date: document.getElementById("pre_operation_date").value,
      scheduling_from: document.getElementById("scheduling_from").value,
      scheduling_deadline: document.getElementById("scheduling_deadline").value,
      description: document.getElementById("description").value,

    };
    console.log(pre_op_request);
    addSurgerySurgical(pre_op_request).then(res => {
      console.log(res.status)
      if (res.status === 201) {
        console.log(res.statusText)
        this.setState({ message: res.statusText })
        this.setState({ isFailure: false });
        this.setState({ alertShow: true });
      }
      else {
        this.setState({ message: res.statusText })
        this.setState({ isFailure: true });
        this.setState({ alertShow: true });
      }
    })
  }

  render() {
    // const currOptions = this.state.patientO===null? []: this.state.patientO.map(opt =>{return({
    //   label: opt.id + " - " + opt.name,
    //   value: opt.id
    // })})

    // const filterOption = (option, inputValue) => {
    //   const { label, value } = option;
    //   const otherKey = currOptions.filter(
    //     opt => opt.label.includes(label) && opt.value.includes(inputValue)
    //   );
    //   return value.includes(inputValue) || otherKey.length > 0;
    // };


    function MyVerticallyCenteredModal(props) {

      const [failed, setFailed] = useState(false)
      const [message, setMessage] = useState('')
      const [alertShow, setAlertShow] = useState(false)

      function onSubmitModal(e) {
        e.preventDefault();

        const patient_to_add = {

          patient_id: document.getElementById("patient_id").value,
          first_name: document.getElementById("first_name").value,
          last_name: document.getElementById("last_name").value,
          gender: document.getElementById("gender").value,
          address: document.getElementById("address").value,
          phone_number: document.getElementById("phone_number").value,
          date_of_birth: document.getElementById("date_of_birth").value,
          email: document.getElementById("email").value,
        };
        console.log(patient_to_add)
        addPatient(patient_to_add).then(res => {
          if (res.status === 201) {
            setFailed(false);
            setMessage(res.statusText);
            setAlertShow(true);
            console.log(failed);
          }
          else {
            setFailed(true);
            setMessage(res.statusText);
            setAlertShow(true);
            console.log(failed);
          }
        })
      }
      let alertClose = () => setAlertShow(false)
      let alertOpen = () => setAlertShow(true)

      return (

        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Patient Information
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="overlay"></div>
            <Container>
              <Form onSubmit={onSubmitModal}>
                <Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId="patient_id">
                      <Form.Label>Patient ID:</Form.Label>
                      <Form.Control type="text" />
                    </Form.Group>

                    <Form.Group as={Col} controlId="first_name">
                      <Form.Label>First Name:</Form.Label>
                      <Form.Control type="text" />
                    </Form.Group>
                    <Form.Group as={Col} controlId="last_name">
                      <Form.Label>Last Name:</Form.Label>
                      <Form.Control type="text" />
                    </Form.Group>

                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId="gender">
                      <Form.Label>Gender</Form.Label>
                      <Form.Control as="select">
                        <option value="m">Male</option>
                        <option value="f">Female</option>
                      </Form.Control>
                    </Form.Group>
                    <Form.Group as={Col} controlId="address">
                      <Form.Label>Address:</Form.Label>
                      <Form.Control type="text" />
                    </Form.Group>
                    <Form.Group as={Col} controlId="phone_number">
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control type="text">
                      </Form.Control>
                    </Form.Group>


                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId="date_of_birth">
                      <Form.Label>Date of Birth</Form.Label>
                      <Form.Control type="date">
                      </Form.Control>
                    </Form.Group>
                    <Form.Group as={Col} controlId="email">
                      <Form.Label>Email</Form.Label>
                      <Form.Control type="text">
                      </Form.Control>
                    </Form.Group>
                  </Form.Row>
                </Form.Row>

              </Form>
            </Container>
          </Modal.Body>
          {/* { failed ? <p>Error! {message}</p> : null } */}
          <AlertGen message={message} show={alertShow} onHide={alertClose} onOpen={alertOpen} isFailure={failed}></AlertGen>


          <Modal.Footer>

            <Button onClick={onSubmitModal}>Submit</Button>
            <Button variant="danger" onClick={props.onHide}>Close</Button>
          </Modal.Footer>
        </Modal>
      );
    }


    // let EventModalClose = () => this.setState({EventModalShow: false});
    let patientModalClose = () => this.setState({ addPatientModalShow: false });
    let alertClose = () => this.setState({ alertShow: false });
    let alertOpen = () => this.setState({ alertShow: true });

    return (
      <>
        <style type="text/css">
          {`
          .btn-flat {
            background-color: blue;
          }
          `}
        </style>
        <div className="overlay"></div>
        <Container>
          <h1>Add a Surgery Request Form</h1>
          <Form onSubmit={this.onSubmit}>
            <Form.Row>
              <Form.Group as={Col} controlId="patient_id">
                <Form.Label>Patient ID:</Form.Label>
                <Select options={this.state.patientO} onChange={this.printPatientId} />
              </Form.Group>

              <Form.Group as={Col} controlId="patient_id">

              </Form.Group>

              <Button variant='primary' onClick={() => this.openModal()}>
                Add Patient
                        </Button>

            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} controlId="request_id">
                <Form.Label>Request ID:</Form.Label>
                <Form.Control type="number" />
              </Form.Group>
              <Form.Group as={Col} controlId="surgery_type">
                <Form.Label>Surgery Type</Form.Label>
                <Form.Control as="select">
                  <option>{null}</option>
                  {this.state.surgeryTO ? this.state.surgeryTO : null}
                </Form.Control>
              </Form.Group>
            </Form.Row>



            <Form.Row>




              <Form.Group as={Col} controlId="status">
                <Form.Label>Status</Form.Label>
                <Form.Control as="select">
                  <option value="1.1">Ready To Go</option>
                  <option value="1.2">Not Ready To Go</option>
                  <option value="1.3">No Pre Operation Examine Date</option>
                  <option value="2">Closed</option>
                  <option value="3">Done</option>
                  <option value="4">Summoned To a Surgery</option>
                </Form.Control>
              </Form.Group>



              <Form.Group as={Col} controlId="urgency">
                <Form.Label>Urgency</Form.Label>
                <Form.Control as="select">
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                </Form.Control>
              </Form.Group>



              <Form.Group as={Col} controlId="complexity">
                <Form.Label>Complexity</Form.Label>
                <Form.Control as="select">
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                </Form.Control>
              </Form.Group>


              <Form.Group as={Col} controlId="duration">
                <Form.Label>Duration (in minutes)</Form.Label>
                <Form.Control type="number">
                </Form.Control>
              </Form.Group>

              <Form.Group as={Col} controlId="cancellations">
                <Form.Label>Cancellations</Form.Label>
                <Form.Control type="number"></Form.Control>
              </Form.Group>

            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} controlId="scheduling_from">
                <Form.Label>Start Date of Scheduling</Form.Label>
                <Form.Control type="date"></Form.Control>
              </Form.Group>
              <Form.Group as={Col} controlId="scheduling_deadline">
                <Form.Label>End Date of Scheduling</Form.Label>
                <Form.Control type="date"></Form.Control>
              </Form.Group>
              <Form.Group as={Col} controlId="specific_senior">
                <Form.Label>Specific Senior Surgeon?</Form.Label>
                <Form.Control as="select">
                  <option>{null}</option>
                  {this.state.seniorTO ? this.state.seniorTO : null}
                </Form.Control>
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} controlId="pre_operation_date">
                <Form.Label>Pre Operation Examine Date</Form.Label>
                <Form.Control type="date"></Form.Control>
              </Form.Group>

              <Form.Group as={Col} controlId="description">
                <Form.Label>Description</Form.Label>
                <Form.Control type="text"></Form.Control>
              </Form.Group>

            </Form.Row>

            <AlertGen message={this.state.message} show={this.state.alertShow} onHide={alertClose} onOpen={alertOpen} isFailure={this.state.isFailure}></AlertGen>

            <Button variant="primary" type="submit">
              Submit
                        </Button>
          </Form>
        </Container>
        <MyVerticallyCenteredModal
          show={this.state.addPatientModalShow}
          onHide={patientModalClose}
          surgeryto={this.state.surgeryTO}
          state_to_send={this.state}
        // onNoteChange = {this.onNoteChange}
        />
      </>
    )
  }
};

export default AddSurgeryRequest
